export default "__VITE_ASSET__CV0h0u7v__"